<script setup lang="ts">
    import { computed, onMounted, reactive, ref, toRaw } from 'vue';
    import axios from 'axios';
import { formatAmount } from '@/utils';
    
    const errorMessage = ref('');
    const loading = ref(false);
    const itemsList = ref([] as any[]);
    const queryParams = reactive({
        pageNumber: 1,
        sortDir: 'ASC',
        sortColumn: 'nom',
        sortOption: 'nom_asc',
    });
    const pagination = reactive({
        total: 0,
        per_page: 10,
        last_page: 1
    });
    const SORT_OPTIONS = [
        { value: 'nom_asc', label: 'Nom (ASC)', sort_column: 'nom', sort_direction: 'ASC' },
        { value: 'nom_desc', label: 'Nom (DESC)', sort_column: 'nom', sort_direction: 'DESC' },
        { value: 'created_at_asc', label: 'Date (ASC)', sort_column: 'created_at', sort_direction: 'ASC' },
        { value: 'created_at_desc', label: 'Date (DESC)', sort_column: 'created_at', sort_direction: 'DESC' },
    ];

    onMounted(() => {
        doListItems();
    });

    async function doListItems() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const queryParamsRaw = toRaw(queryParams);
            const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
            const httpResponse = await axios.get(`/backoffice/finance/decaissements/list_collectivites?${queryString}`);
            itemsList.value = httpResponse.data.data;
            pagination.total = httpResponse.data.total;
            pagination.per_page = httpResponse.data.per_page;
            pagination.last_page = httpResponse.data.last_page;
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

    function onPaginate(pageNumber: number) {
        queryParams.pageNumber = pageNumber;
        doListItems();
    }
    function getPrelevementPercentage(collectivite: any) {
        if (!collectivite.prelevement) {
            return 0;
        }
        return collectivite.prelevement.montant_prelevement && collectivite.prelevement.montant_prelevement_expected
            ? Math.min(100, (collectivite.prelevement.montant_prelevement / collectivite.prelevement.montant_prelevement_expected) * 100).toFixed(0)
            : 0;
    }

</script>
<template>
    <section class="container-full-app bg-grey-50">
        <div class="page-space-30"></div>

        <!--*** Widget *** -->
        <section class="s20">
            <div class="widget shadow-100 s20 pb-2"><!-- widget shadow-100 fill -->
                <!--Card-->
                <div class="container-full-2 s20 my-5">
                    <div class="s7"><h4 class="font-semibold mt-4">Décaissements <span class="text-sm text-grey-500">(recent)</span></h4></div>
                    <div class="s13 flex justify-content-right">
                        <div class="form-field-floating default sm s4_mobile ml-3">
                            <select class="form-input-select" name="pays" id="pays">
                                <option value="" selected>Période</option>
                                <option value="">Ordre Décroissant</option>
                                <option value="">Ordre Croissant</option>
                                <option value="">De A - Z</option>
                                <option value="">De Z - A</option>
                            </select>
                        </div>
                        <div class="form-field-floating default sm s4_mobile ml-3">
                            <select class="form-input-select" name="pays" id="pays">
                                <option value="">Trier</option>
                                <option value="" selected>Ordre Décroissant</option>
                                <option value="">Ordre Croissant</option>
                                <option value="">De A - Z</option>
                                <option value="">De Z - A</option>
                            </select>
                        </div>
                        <button class="btn normal white2 s3_mobile ml-4 justify-content-center btn-filtre btn-filter">
                            <img src="/icons/icon-filter.svg" class="btn-icon" alt="" />
                            <span>Options</span>
                        </button>
                    </div>
                    <div class="clear-both"></div>
                    <!--Options-->
                    <div class="filter-set-area">
                        <div class="grid-filter6 mt-4 mb-0">
                            <div class="form-field-floating reactive sm">
                                <input type="date" class="form-input" name="date1" id="date1" placeholder="">
                                <label for="date1">Date de création &lt;=</label>
                            </div>
                            <div class="form-field-floating reactive sm">
                                <input type="date" class="form-input" name="date2" id="date2" placeholder="">
                                <label for="date2">Date de création &gt;=</label>
                            </div>
                            <div class="form-field-floating sm">
                                <select class="form-input-select" name="pays" id="pays">
                                    <option value="" selected>Tout les etats</option>
                                    <option value="">Actif</option>
                                    <option value="">Inactif</option>
                                </select>
                                <label for="pays">Etat <b class="color-danger">*</b></label>
                            </div>
                            <div class="form-field-floating sm">
                                <select class="form-input-select" name="pays" id="pays">
                                    <option value="" selected>Tout les etats</option>
                                    <option value="">Actif</option>
                                    <option value="">Inactif</option>
                                </select>
                                <label for="pays">Etat <b class="color-danger">*</b></label>
                            </div>
                            <button class="btn black normal justify-content-center mx-0 btn-filtre">
                                <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                                <span>Exporter Excel</span>
                            </button>
                            <button class="btn black normal justify-content-center mx-0 btn-filtre">
                                <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                                <span>Exporter PDF</span>
                            </button>
                        </div>
                    </div>
                    <!---->
                </div>
            </div>

            <div>
                <table class="table separator skin3 selection rounded"><!-- selection skin1 skin2 (bg1 bg2 bg3)  (skin3 rounded)  sm-->
                    <thead>
                        <tr>
                            <th><label class="btn-circle" for="check-list1"><input type="checkbox" name="check-list" id="check-list1" /></label></th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /></th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Période</th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Date / Etat</th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Membres</th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Prélèvement</th>
                            <th><img src="/icons/icon-filter-up.svg" class="size-xxs mt--1" alt="" /> Décaissement</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="loading">
                            <tr>
                                <td colspan="9" class="text-center py-5">
                                    <div style="display: flex; justify-content: center" v-if="loading">
                                        <div class="loader dark"></div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-else-if="itemsList.length === 0">
                            <tr>
                                <td colspan="9" class="text-center py-5">
                                    Aucune fichier de prélèvement trouvée.
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr class="text-grey-700 over-effect" v-for="(collectivite, index) in itemsList" :key="'collectivite_' + index"><!-- over-effect active-->
                                <td class="selection-item bg-color-1000">
                                    <div class="square-xxl rounded-15 ml-3 px-3 py-3" style="background-color: rgb(var(--color-white-rgb), 1);"><img :src="'/assets/logos/logo' + ((index % 5) + 1) + '.svg'" width="100%" /></div>
                                </td>
                                <td class="bg-color-1000" style="width: 15%;">
                                    <router-link :to="'/app/finance/decaissements/' + collectivite.id">
                                        <p class="text-xl font-semibold mb-2 text-white">
                                            {{ collectivite.nom }} <br class="mb-3"> 
                                            C788PMKJ &nbsp;
                                            <span class="tag-state notif stroke">Actif</span>
                                        </p>
                                    </router-link>
                                </td>
                                <td class="font-semibold bg-color-800 pl-6" style="width: 10%;">
                                <h4 class="text-white">{{ collectivite.prelevement ? collectivite.prelevement.periode_prelevement_formatted : '-'  }}</h4>
                                </td>
                                <td class="font-semibold" style="width: 10%;">
                                    <span class="tag-state success stroke">{{ collectivite.prelevement ? collectivite.prelevement.status_prelevement_label : '-' }}</span><br class="mb-5" />
                                    {{ collectivite.prelevement ? collectivite.prelevement.created_at_formatted : '-' }}
                                </td>
                                <td class="text-3xl " style="width: 10%;">
                                    {{ collectivite.users_count }}
                                </td>
                                <td>
                                    <!--Barre de progression - Component-->
                                    <div class="h-40 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                                        <div class="widget-floating py-0 text-xl flex-right">{{ getPrelevementPercentage(collectivite) }}%</div>
                                        <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl bg-pop-yellow" :style="{'width': getPrelevementPercentage(collectivite) + '%'}">
                                            <div class="text-2xl position-absolute px-7">{{ collectivite.prelevement != null ? formatAmount(collectivite.prelevement.montant_prelevement) + ' F /' + formatAmount(collectivite.prelevement.montant_prelevement_expected) + ' F' : '-' }}</div>
                                        </div>
                                    </div>
                                    <!--End Barre de progression-->
                                </td>
                                <td>
                                    <!--Barre de progression - Component-->
                                    <div class="h-60 rounded-100 position-relative" style="width: 100%; background-color: rgba(var(--color-black-rgb), 0.1);">
                                        <div class="widget-floating py-0 text-xl flex-right text-white">100%</div>
                                        <div class="h-100p flex align-items-center justify-content-left rounded-100 text-2xl bg-color-1000" style="width: 100%;">
                                            <div class="text-3xl position-absolute text-white px-7">1 900 000 F / 1 900 000 F</div>
                                        </div>
                                    </div>
                                    <!--End Barre de progression-->
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="clear-both h-30"></div>
            
        </section>
        
        <div class="clear-both h-30"></div>
    </section>
</template>